import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <h4>Company</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4>Services</h4>
          <ul>
            <li><Link to="/services">Painting</Link></li>
            <li><Link to="/services">Flooring</Link></li>
            <li><Link to="/services">Countertops</Link></li>
          </ul>
        </div>
        <div>
          <h4>Contact</h4>
          <ul className="contact-list">
            <li><a href="tel:+13435963222">(343) 596-3222</a></li>
            <li><a href="mailto:anas@bugnotpaintingandreno.com">anas@bugnotpaintingandreno.com</a></li>
            <li>Ottawa, Ontario</li>
          </ul>
          <Link to="/contact" className="btn btn-primary small">Request a Free Quote</Link>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <p>© {year} Bugnot Painting and Renovation — Painting & Renovation. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
